export const GET_EVENTS_REQUEST = 'GET_EVENTS_REQUEST';
export const GET_EVENTS_SUCCESS = 'GET_EVENTS_SUCCESS';
export const GET_EVENTS_FAIL = 'GET_EVENTS_FAIL';
export const GET_EVENTS_CANCEL = 'GET_EVENTS_CANCEL';
export const getEventsRequest = (data, abortController) => ({
  type: GET_EVENTS_REQUEST,
  payload: data,
  abortController,
});
export const cancelEventsRequest = () => ({
  type: GET_EVENTS_CANCEL,
});

export const UPDATE_EVENT = 'UPDATE_EVENT';
export const updateEvent = (data) => ({
  type: UPDATE_EVENT,
  payload: data,
});

export const REMOVE_EVENT = 'REMOVE_EVENT';
export const removeEvent = (data) => ({
  type: REMOVE_EVENT,
  payload: data,
});
